module.exports = __webpack_public_path__ + "static/media/world_06.23a9c7ad.png";